// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__3jH-M","message":"Error_message__1ULuO","retry":"Error_retry__2Uv2S"};